import { Box, Button, Image, Stack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { AiOutlineCheck } from "react-icons/ai";
import { IMG } from '../../../Content/Content';
function Pricing() {
    const SinglePacks = [
        {
            credits: "100",
            month: "/ 10$",
            id: "1"
        },
        {
            credits: "100",
            month: "/ 10$",
            id: "2"
        },
        {
            credits: "100",
            month: "/ 10$",
            id: "3"
        },

        {
            credits: "100",
            month: "/ 10$",
            id: "3"
        },


        {
            credits: "100",
            month: "/ 10$",
            id: "3"
        },


    ]
    const SubscriptionPacks = [
        {
            credits: "100",
            title: "Beginner",
            details1: "Get more product to add",
            details2: "Get more product to add",
            details3: "Get more product to add",
            details4: "Get more product to add",
        },
        {
            credits: "200",
            title: "Passionate",
            details1: "Get more product to add",
            details2: "Get more product to add",
            details3: "Get more product to add",
            details4: "Get more product to add",
        },
        {
            credits: "400",
            title: "Expert",
            details1: "Get more product to add",
            details2: "Get more product to add",
            details3: "Get more product to add",
            details4: "Get more product to add",
        },
        {
            credits: "300",
            title: "Artist",
            details1: "Get more product to add",
            details2: "Get more product to add",
            details3: "Get more product to add",
            details4: "Get more product to add",
        }
    ]
    return (
        <VStack paddingBottom="50px">
            <Box textAlign="left" w="100%" paddingTop="40px" >
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Single Use Packs</Text>
            </Box>

            {/* products */}

            <Box display="flex" alignItems="start" justifyContent="start" flexWrap="wrap" w="100%">
                {
                    SinglePacks.map((item) => (
                        <Box w="247px" margin="10px" h="120px" bg="#F5F5F5" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="flex" alignItems="center" justifyContent="center" borderRadius="8px">
                            <Box bg="#fff" w="90%" h="88px" display="flex" alignItems="stretch" flexDirection="column" justifyContent="space-around" p="10px" borderRadius="8px">
                                <Box >
                                    <Text className="g-text" fontSize="24px" fontWeight="500">{item.credits} Credits <span className="g-text">{item.month}</span></Text>
                                </Box>
                                <Box textAlign="right">
                                    <Button type="button" className='gb-button' fontSize="12px" padding="5px 20px" fontWeight="600">Buy Now</Button>
                                </Box>
                            </Box>
                        </Box>
                    ))
                }
            </Box>

            <Box textAlign="left" w="100%" paddingTop="40px">
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Subscription Packs</Text>
            </Box>

            {/* Subscription Packs */}
            <Stack w="100%" paddingX="25px">
                <Box display="flex" alignItems="start" justifyContent="space-between" flexWrap="wrap" w="100%">
                    {
                        SubscriptionPacks.map((item) => {
                            return (
                                <Box w="300px" >
                                    <Box  textAlign="center"
                                        borderRadius="10px"
                                        border="1px solid rgba(236, 233, 233, 0.15)"
                                        boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                                        bg="#F5F5F5"
                                        marginBottom="25px"
                                        h="447px"
                                    >
                                        <Text className='title'
                                            fontSize="22px"
                                            fontWeight="700"
                                            lineHeight="27px"
                                            paddingY="5"
                                        > {item.title}</Text>

                                        {/* description */}
                                        <Text fontSize="14px"
                                            fontWeight="400"
                                            lineHeight="22px"
                                            paddingY="2px">Lorem ipsum dolor sit amet consectetur.</Text>

                                        {/* credits */}
                                        <Text
                                            paddingY="5"
                                            className="g-text" fontSize="22px" fontWeight="700">{item.credits} Credits <span style={{ fontWeight: "400", fontSize: "16px" }} className="g-text">/ Month</span></Text>

                                        <Box width="250px" margin="auto" bg="#FFFFFF" h="234px" borderRadius="5px" display="flex" flexDirection="column" alignItems="center" justifyContent="center">

                                            <Box display="flex" alignItems="center" justifyContent="center" paddingY="5px">
                                                <Text 
                                                fontSize="12px"
                                                bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)" w="13px" h="13px" display="flex" justifyContent="center" alignItems="center"
                                                    borderRadius="25px" color="#fff">
                                                    <AiOutlineCheck />
                                                </Text>

                                                <Text fontSize="14px" color="rgba(0, 0, 0, 0.84)" fontWeight="400" paddingLeft="3px">Get more product to add</Text>
                                            </Box>

                                            <Box display="flex" alignItems="center" justifyContent="center" paddingY="5px">
                                                <Text bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)" w="13px" h="13px" display="flex" justifyContent="center" alignItems="center"
                                                    borderRadius="25px" color="#fff">
                                                    <AiOutlineCheck />
                                                </Text>

                                                <Text fontSize="14px" color="rgba(0, 0, 0, 0.84)" fontWeight="400" paddingLeft="3px">Get more product to add</Text>
                                            </Box>


                                            <Box display="flex" alignItems="center" justifyContent="center" paddingY="5px">
                                                <Text bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)" w="13px" h="13px" display="flex" justifyContent="center" alignItems="center"
                                                    borderRadius="25px" color="#fff">
                                                    <AiOutlineCheck />
                                                </Text>

                                                <Text fontSize="14px" color="rgba(0, 0, 0, 0.84)" fontWeight="400" paddingLeft="3px">Get more product to add</Text>
                                            </Box>

                                            <Box display="flex" alignItems="center" justifyContent="center" paddingY="5px">
                                                <Text bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)" w="13px" h="13px" display="flex" justifyContent="center" alignItems="center"
                                                    borderRadius="25px" color="#fff">
                                                    <AiOutlineCheck />
                                                </Text>

                                                <Text fontSize="14px" color="rgba(0, 0, 0, 0.84)" fontWeight="400" paddingLeft="3px">Get more product to add</Text>
                                            </Box>

                                            <Box marginTop="15px">
                                                <Button
                                                    w="93px"
                                                    h="30px"
                                                    display="flex"
                                                    justifyContent="center"
                                                    alignItems="center"
                                                    borderRadius="5px"
                                                    type="button"
                                                    className='gb-button'
                                                    fontSize="14px"
                                                    fontWeight="600"
                                                    lineHeight="30px"
                                                >Buy Now</Button>
                                            </Box>
                                        </Box>
                                    </Box>

                                </Box>
                            )
                        })
                    }
                </Box>
            </Stack>

            {/* Earn Credits Free */}
            <Box textAlign="left" w="100%" paddingTop="60px">
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Earn Credits Free</Text>
            </Box>
            <Stack
             flexDirection="row" 
             flexWrap="wrap"
             w="100%" 
             alignItems="center" 
             justifyContent="start" 
             paddingLeft="20px" 
             paddingTop="40px"
             >
            <Box 
                w="247px" 
                marginRight="20px !important" 
                marginTop="0 !important"  
                h="120px" bg={`url(${IMG.bg1})`} 
                boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" 
                display="flex" 
                alignItems="center" 
                justifyContent="center" 
                borderRadius="8px"
            >
                <Box bg=" transparent" w="90%" h="88px" display="flex" alignItems="center" flexDirection="column" justifyContent="center" p="10px" position="relative">
                    <Image src={IMG.playIcon} w="60px" />

                    <Text position="absolute" top="0" left="0" fontSize="10px" fontWeight="400" color="#fff">
                        Watch video & get credits
                    </Text>
                </Box>
            </Box>      

            <Box w="247px" marginRight="20px !important"marginTop="0 !important"  h="120px" bg="#F5F5F5" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="flex" alignItems="center" justifyContent="center" borderRadius="8px">
                <Box bg="#fff" w="90%" h="88px" display="flex" alignItems="center" flexDirection="column" justifyContent="center" p="10px" position="relative">
                    <Image src={IMG.share} w="20px" />
                    <Text position="absolute" top="5px" left="5px" fontSize="10px" fontWeight="400" color="rgba(0, 0, 0, 0.84)">
                    Share & get credits Now
                    </Text>
                </Box>
            </Box>

            <Box w="247px"  marginLeft="20px" marginTop="0 !important" h="120px" bg="#F5F5F5" boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="flex" alignItems="center" justifyContent="center" borderRadius="8px">
                <Box bg="#fff" w="90%" h="88px" display="flex" alignItems="center" flexDirection="column" justifyContent="center" p="10px" position="relative">
                    <Image src={IMG.earn} w="20px" />
                    <Text position="absolute" top="5px" left="5px" fontSize="10px" fontWeight="400" color="rgba(0, 0, 0, 0.84)">
                    Share & get credits Now
                    </Text>
                </Box>
            </Box>
            </Stack>

        </VStack>
    )
}

export default Pricing
